// import React, { useEffect, useState } from "react";
// import { getInvoices, deleteInvoice } from "../Services/InvoicePageService";
// import { useNavigate } from "react-router-dom";
// import "../Style/InvoiceForm.css";
// import { IInvoiceData } from "../Interfaces/IInvoice";
// import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
// import { parseISO, format } from "date-fns";
// import "../Style/Common.css";
// import Footer from "../Footer/Footer";
// import Swal from "sweetalert2";
// import { Tooltip, IconButton, Box, Container } from "@mui/material";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";

// const ViewInvoice: React.FC = () => {
//   const navigate = useNavigate();
//   const [invoices, setInvoices] = useState<IInvoiceData[]>([]);
//   const [filteredInvoices, setFilteredInvoices] = useState<IInvoiceData[]>([]);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 10,
//   });
//   const [searchText, setSearchText] = useState("");
//   const orgId = localStorage.getItem("orgId") || "GOO@PANACCO101";
//   useEffect(() => {
//     const fetchInvoices = async () => {
//       Swal.fire({
//         title: "<strong>Fetching Invoices</strong>",
//         html: "<i>Please wait while we fetch the data</i>",
//         allowOutsideClick: false,
//         width: 400,
//         padding: "1rem",
//         didOpen: () => {
//           Swal.showLoading();
//         },
//         background: "#f0f0f0",
//         showConfirmButton: false,
//       });
//       try {
//         const data = await getInvoices(orgId);
   

//         const invoicesWithId = data.map((invoice: { invoiceId: any }) => ({
//           ...invoice,
//           id: invoice.invoiceId, // Use invoiceId as the unique id
//         }));
//         setInvoices(invoicesWithId);
//         setFilteredInvoices(invoicesWithId);
       
//       } catch (error) {
//         console.error("Failed to fetch invoices:", error);
//       } finally {
//         Swal.close();
//       }
//     };
//     fetchInvoices();
//   }, [orgId]);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       const lowercasedSearchText = searchText.toLowerCase();
//       const filtered = invoices.filter(
//         (invoice) =>
//           invoice.invoiceId?.toLowerCase().includes(lowercasedSearchText) ||
//           invoice.customerName?.toLowerCase().includes(lowercasedSearchText) ||
//           invoice.salesPersonName
//             ?.toLowerCase()
//             .includes(lowercasedSearchText) ||
//           invoice.orderId?.toLowerCase().includes(lowercasedSearchText)
//       );
//       setFilteredInvoices(filtered);
//     }, 300); // 300ms debounce
//     return () => clearTimeout(timer);
//   }, [searchText, invoices]);

//   const handleDelete = async (invoiceId: string, invoiceType: string) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You will not be able to recover this invoice!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await deleteInvoice(invoiceId, orgId, "sysAdmin", invoiceType);
//           setInvoices(
//             invoices.filter((invoice) => invoice.invoiceId !== invoiceId)
//           );
//           setFilteredInvoices(
//             filteredInvoices.filter(
//               (invoice) => invoice.invoiceId !== invoiceId
//             )
//           );
//           Swal.fire("Deleted!", "Invoice has been deleted.", "success");
//         } catch (error) {
//           console.error("Failed to delete invoice:", error);
//         }
//       }
//     });
//   };

//   const handleView = async (invoice: any) => {
//     localStorage.setItem("customerId", invoice.customerId);
//     //navigate("/dashboard/sales/view-invoice-details", { state: { invoice } });
//     window.open(`/dashboard/sales/view-invoice-details?invoiceId=${invoice.invoiceId}`, "_blank");
//   };
//   const columns: GridColDef[] = [
//     {
//     field: "actions",
//     headerName: "Actions",
//     width: 120,
//     sortable: false,
//     filterable: false,
//     renderCell: (params) => (
//       <>
//       {/* // <Box display="flex" > */}
//         <Tooltip title="View Invoice" arrow>
//           <IconButton size="small" sx={{ padding: 0 }}
//             onClick={() => handleView(params.row)}           
//             color="primary"
//             style={{ marginLeft: 8 }}
//           >
//             <VisibilityIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>

//         <Tooltip title="Edit Invoice" arrow>
//           <IconButton  size="small" sx={{ padding: 0 }}
//             onClick={() =>
//               navigate("/dashboard/sales/edit-invoice", {
//                 state: { invoice: params.row },
//               })
//             }          
           
//             style={{ marginLeft: 8 }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>

//         <Tooltip title="Delete Invoice" arrow>
//           <IconButton size="small" sx={{ padding: 0}}
//             onClick={() => handleDelete(params.row.invoiceId,params.row.invoiceType)}            
//             color="error"
//             style={{ marginLeft: 8 }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//         </>
//       // </Box>
//     ),
//   },
//     { field: "invoiceId", headerName: "Invoice ID", width: 160,renderCell: (params) => (
//       <span
//         onClick={() => handleView(params.row)}
//         style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
//       >
//         {params.value}
//       </span>
//     )},
//     { field: "customerName", headerName: "Customer Name", width: 200 },
//     // { field: "salesPersonName", headerName: "Salesperson", width: 200 },
//     {
//       field: "invoiceDate",
//       headerName: "Invoice Date",
//       width: 120,
//       valueGetter: (params: GridRenderCellParams) => {
//         //console.log("params", params);
//         const dateStr = params;
//         // Check if dateStr is defined and a valid string
//         if (dateStr && typeof dateStr === "string") {
//           try {
//             const date = parseISO(dateStr); // Parse the ISO date string
//             if (!isNaN(date.getTime())) {
//               // Properly format the date as MM/DD/YYYY
//               return format(date, "dd/MM/yyyy");
//             }
//           } catch (error) {
//             console.error("Error parsing date:", error);
//           }
//         }
//         return "N/A"; // If there's no valid invoiceDate or parsing failed
//       },
//     },

//     { field: "orderId", headerName: "Order Number", width: 110 },
//     {
//       field: "subTotalAmount",
//       headerName: "Subtotal",
//       width: 100,
//       valueFormatter: (subTotalAmount) =>
//         `${Number(subTotalAmount).toFixed(2)}`,
//     },
//      {
//       field: "totalTax",
//       headerName: "GST Amt",
//       width: 90,
//       valueFormatter: (totalTax) =>
//         `${Number(totalTax).toFixed(2)}`,
//     },
//     {
//       field: "totalDiscount",
//       headerName: "Disc Amt",
//       width: 90,
//       valueFormatter: (totalDiscount) =>
//         `${Number(totalDiscount).toFixed(2)}`,
//     },
//     {
//       field: "grandTotal",
//       headerName: "Total",
//       width: 100,
//       valueFormatter: (grandTotal) =>
//         `${Number(grandTotal).toFixed(2)}`,
//     },
    
//   ];
//   return (
//     <>
//       {/* <div className="container"> */}
//       <div className="page-location">
//           <span>Sales &gt; View Invoice</span>
//         </div>
//       <Container maxWidth="lg" sx={{ padding: 1 }}>
        
//         <div style={{ height: 600, width: "100%" }}>
//           {/* Stylish Search Bar */}
//           <div style={{ position: "relative", width: "50%" }}>
//             <input
//               type="text"
//               placeholder="🔍 Search by invoice id,customer name, Salesperson, order number, invoice date..."
//               value={searchText}
//               onChange={(e) => setSearchText(e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "0.75rem 2.5rem 0.75rem 1rem",
//                 borderRadius: "25px",
//                 border: "1px solid #ccc",
//                 fontSize: "1rem",
//                 outline: "none",
//                 boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
//               }}
//             />
//             <span
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "1rem",
//                 transform: "translateY(-50%)",
//                 color: "#999",
//                 pointerEvents: "none",
//               }}
//             >
//               🔍
//             </span>
//           </div>
//           <DataGrid
//             rows={filteredInvoices}
//             columns={columns}
//             pagination
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={[10, 20, 50]}
//             rowCount={filteredInvoices.length}
//             sx={{
//               "& .MuiDataGrid-main": {
//                 overflowX: "hidden", // Remove the horizontal scrollbar
//               },
//               "& .MuiTablePagination-select": {
//                 minWidth: "60px", // Set the dropdown width
//                 fontSize: "0.875rem", // Smaller font size
//                 padding: "0.25rem", // Smaller padding
//               },
//               "& .MuiTablePagination-selectLabel": {
//                 fontSize: "0.875rem", // Smaller font size for label
//               },
//               "& .MuiTablePagination-actions": {
//                 display: "flex",
//                 justifyContent: "space-between",
//                 width: "100px",
//                 gap: "10px",
//                 alignItems: "center",
//                 "& button": {
//                   padding: "0.5rem",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   backgroundColor: "#fff",
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                   },
//                 },
//               },
//               "& .MuiTablePagination-toolbar": {
//                 justifyContent: "flex-start",
//                 "& p": {
//                   fontSize: "1rem",
//                   marginRight: "1rem",
//                 },
//               },
//               "& .MuiDataGrid-row:hover": {
//                 backgroundColor: "#f0f8ff", // light blue
//               },
//               "& .MuiDataGrid-columnHeaders": {
//                 position: "sticky",
//                 top: 0,
//                 zIndex: 1,
//                 backgroundColor: "#fff",
//               },
//               '& .MuiDataGrid-cell:first-of-type': {
//                 position: 'sticky',
//                 left: 0,
//                 backgroundColor: '#fff',
//                 zIndex: 2,
//               },
//               '& .MuiDataGrid-columnHeader:first-of-type': {
//                 position: 'sticky',
//                 left: 0,
//                 backgroundColor: '#f9f9f9',
//                 zIndex: 3,
//               },
//             }}
//           />
//         </div>
//       {/* </div> */}
//       </Container>
//       <Box
//         sx={{
//           position: "relative",
//           left: 0,
//           bottom: 0,
//           width: "100%",
//           mt: "40px",
//         }}
//       >
//         <Footer />
//       </Box>
//     </>
//   );
// };
// export default ViewInvoice;
/**
 * ViewInvoice.tsx  —  PROFESSIONAL REDESIGN
 *
 * What's new vs original:
 *  1. Summary cards (Total Invoiced, Received, Outstanding Due)
 *  2. Smart search + collapsible filters (status, type, date range)
 *  3. Paid Amount + Due Amount columns with colour coding
 *  4. Invoice Type chip badge column
 *  5. Status chip (Paid = green, Due = orange, Cancelled = red)
 *  6. Rows-per-page selector (10 / 25 / 50 / 100)
 *  7. Total count + filtered count in header
 *  8. Mobile card view (responsive)
 *  9. All business logic extracted to useInvoiceList hook
 * 10. Loading skeletons instead of Swal loading popup
 * 11. Error alert with retry button
 * 12. Export to CSV button
 */
import React, { useState } from "react";
import { format, parseISO } from "date-fns";

import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  IconButton,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import DeleteIcon       from "@mui/icons-material/Delete";
import DownloadIcon     from "@mui/icons-material/Download";
import EditIcon         from "@mui/icons-material/Edit";
import ReceiptIcon      from "@mui/icons-material/Receipt";
import VisibilityIcon   from "@mui/icons-material/Visibility";
import WhatsAppIcon     from "@mui/icons-material/WhatsApp";
import Footer              from "../Footer/Footer";
import { IInvoiceData }   from "../Interfaces/IInvoice";
import { useInvoiceList }  from "../Hooks/Sales/useInvoiceList";
import InvoiceListFilters  from "./InvoiceListFilters";
import InvoiceSummaryCards from "./InvoiceSummaryCards";
import PaymentReminderModal from "../Sales/PaymentReminderModal";
import { IReminderInvoice }  from "../Services/PaymentReminderService";
import { getUsersByCustomerId } from "../Services/userService";
// ─── Helpers ──────────────────────────────────────────────────────────────────

const fmtCurrency = (n: any) =>
  `₹${Number(n ?? 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

const fmtDate = (dateStr?: string): string => {
  if (!dateStr) return "—";
  try {
    return format(parseISO(dateStr), "dd/MM/yyyy");
  } catch {
    return dateStr;
  }
};

const statusChip = (status: string) => {
  switch (status) {
    case "paid":   return <Chip label="Paid"      size="small" color="success" variant="outlined" />;
    case "due":    return <Chip label="Due"        size="small" color="warning" variant="outlined" />;
    case "cancel": return <Chip label="Cancelled"  size="small" color="error"   variant="outlined" />;
    default:       return <Chip label="Draft"      size="small" color="default" variant="outlined" />;
  }
};

const typeChip = (type: string) => {
  const map: Record<string, { label: string; color: "default" | "primary" | "secondary" | "info" | "success" | "warning" | "error" }> = {
    "Original":        { label: "Original",   color: "primary"   },
    "GSTInvoice":      { label: "GST",        color: "info"      },
    "QuickInvoice":    { label: "Quick",      color: "secondary" },
    "PerformaInvoice": { label: "Performa",   color: "warning"   },
  };
  const cfg = map[type] ?? { label: type || "—", color: "default" };
  return <Chip label={cfg.label} size="small" color={cfg.color} variant="outlined" />;
};

// ─── CSV Export ───────────────────────────────────────────────────────────────

function downloadCSV(invoices: IInvoiceData[]) {
  const headers = [
    "Invoice ID", "Customer", "Invoice Date", "Due Date", "Type",
    "Subtotal", "GST Amt", "Discount", "Grand Total", "Paid", "Due", "Status",
  ];
  const rows = invoices.map((inv) => [
    inv.invoiceId,
    inv.customerName,
    fmtDate(inv.invoiceDate),
    fmtDate(inv.dueDate),
    inv.invoiceType,
    inv.subTotalAmount,
    inv.totalTax,
    inv.totalDiscount,
    inv.grandTotal,
    inv.totalPaidAmount,
    inv.dueAmount,
    inv.status,
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map((cell) => `"${cell ?? ""}"`).join(","))
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href = url;
  a.download = `invoices_${new Date().toISOString().split("T")[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

// ─── Mobile Invoice Card ──────────────────────────────────────────────────────

interface CardProps { inv: IInvoiceData; onView: () => void; onEdit: () => void; onDelete: () => void;onRemind?: () => void; }

const InvoiceMobileCard: React.FC<CardProps> = ({ inv, onView, onEdit, onDelete,onRemind  }) => (
  <Card
    variant="outlined"
    sx={{
      mb: 1.5, borderRadius: 2,
      borderLeft: "4px solid",
      borderLeftColor:
        inv.status === "paid"   ? "success.main" :
        inv.status === "cancel" ? "error.main"   : "warning.main",
      "&:hover": { boxShadow: 2 },
      transition: "box-shadow 0.2s",
    }}
  >
    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
      {/* Row 1: Invoice ID + Status */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
        <Box>
          <Typography
            variant="body1"
            fontWeight={700}
            color="primary.main"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={onView}
          >
            {inv.invoiceId}
          </Typography>
          <Typography variant="caption" color="text.secondary">{fmtDate(inv.invoiceDate)}</Typography>
        </Box>
        <Stack direction="row" spacing={0.5}>
          {statusChip(inv.status)}
          {typeChip(inv.invoiceType)}
        </Stack>
      </Stack>

      {/* Row 2: Customer */}
      <Typography variant="body1" fontWeight={600} noWrap mb={1}>
        {inv.customerName}
      </Typography>

      <Divider sx={{ my: 1 }} />

      {/* Row 3: Amounts */}
      <Stack direction="row" justifyContent="space-between" mb={1.5}>
        {[
          { label: "Total",       value: fmtCurrency(inv.grandTotal),      color: "text.primary" },
          { label: "Paid",        value: fmtCurrency(inv.totalPaidAmount),  color: "success.main" },
          { label: "Due",         value: fmtCurrency(inv.dueAmount),
            color: Number(inv.dueAmount) > 0 ? "error.main" : "success.main" },
        ].map(({ label, value, color }) => (
          <Box key={label}>
            <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
            <Typography variant="body1" fontWeight={700} color={color}>{value}</Typography>
          </Box>
        ))}
      </Stack>

      {/* Row 4: Actions */}
      <Stack direction="row" justifyContent="flex-end" spacing={0.5}>
        <Tooltip title="View">
          <IconButton size="medium" color="primary"  onClick={onView}><VisibilityIcon fontSize="small" /></IconButton>
        </Tooltip>
        <Tooltip title="Edit">
          <IconButton size="medium" color="default"  onClick={onEdit}><EditIcon fontSize="small" /></IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="medium" color="error"    onClick={onDelete}><DeleteIcon fontSize="small" /></IconButton>
        </Tooltip>
        {onRemind && (
          <Tooltip title="Send Payment Reminder">
            <IconButton size="medium" sx={{ color: "#25D366" }} onClick={onRemind}>
              <WhatsAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </CardContent>
  </Card>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const ViewInvoice: React.FC = () => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const {
    invoices, stats,
    loading, fetchError,
    filters, updateFilter, clearFilters, hasActiveFilters,
    page, pageSize, totalPages, totalCount, setPage, setPageSize,
    sortField, sortOrder, handleSort,
    handleView, handleEdit, handleDelete, handleRefresh,
    exportAll,
  } = useInvoiceList();

  const [showFilters, setShowFilters] = useState(!isMobile);
  const [exporting,   setExporting]   = useState(false);
 // ── Payment Reminder modal state ────────────────────────────────────────
  const [reminderInvoices, setReminderInvoices] = useState<IReminderInvoice[]>([]);
  const [reminderCustomerName, setReminderCustomerName] = useState("");
  const [reminderPhone, setReminderPhone] = useState<string | undefined>(undefined);

   const openReminder = async (inv: IInvoiceData) => {
    // Open the modal immediately with what we already know — don't make
    // the user wait on a network call just to see the dialog.
    setReminderInvoices([
      {
        invoiceId: inv.invoiceId,
        dueAmount: Number(inv.dueAmount ?? 0),
        dueDate: inv.dueDate,
      },
    ]);
    setReminderCustomerName(inv.customerName || "Customer");
    setReminderPhone(undefined); // clear any number left over from a previous invoice

    // If the invoice payload itself already carries a phone (some flows
    // do), use it directly — no need for an extra lookup.
    const inlinePhone = (inv as any).phone;
    if (inlinePhone) {
      setReminderPhone(inlinePhone);
      return;
    }

    // Otherwise, look the customer up the same way every other screen in
    // this app does — by customerId — and pull their stored phone number.
    const customerId = (inv as any).customerId;
    const orgId = localStorage.getItem("orgId") ?? "";
    if (!customerId || !orgId) return; // modal's phone field stays editable/blank

    try {
      const users = await getUsersByCustomerId(orgId, customerId);
      const phone = users?.[0]?.phone;
      if (phone) setReminderPhone(phone);
    } catch (err) {
      // Customer lookup failing shouldn't block sending a reminder — the
      // user can just type the number in manually.
      console.warn("Could not look up customer phone for payment reminder:", err);
    }
  };
  const serialOffset = page * pageSize;

  const handleExport = async () => {
    setExporting(true);
    try {
      const all = await exportAll();
      downloadCSV(all);
    } catch {
      // Export failing shouldn't disrupt the page — silently no-op.
    } finally {
      setExporting(false);
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <>
      <div className="page-location">
        <span>Sales &gt; View Invoice</span>
      </div>

      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 }, py: 1 }}>

        {/* ── Page Header ─────────────────────────────────────────────── */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <ReceiptIcon color="primary" fontSize={isMobile ? "small" : "medium"} />
            <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={700}>
              Invoices
            </Typography>
          </Stack>
          <Tooltip title="Export filtered invoices to CSV">
            <span>
              <Button
                size="small"
                variant="outlined"
                startIcon={<DownloadIcon />}
                onClick={handleExport}
                disabled={exporting || totalCount === 0}
              >
                {exporting ? "Exporting…" : isMobile ? "CSV" : "Export CSV"}
              </Button>
            </span>
          </Tooltip>
        </Stack>

        {/* ── Error ─────────────────────────────────────────────────────── */}
        {fetchError && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            action={<Button size="small" onClick={handleRefresh}>Retry</Button>}
          >
            {fetchError}
          </Alert>
        )}

        {/* ── Summary Cards ─────────────────────────────────────────────── */}
        <InvoiceSummaryCards stats={stats} loading={loading} isMobile={isMobile} />

        {/* ── Filters ───────────────────────────────────────────────────── */}
        <InvoiceListFilters
          filters={filters}
          hasActiveFilters={hasActiveFilters}
          showFilters={showFilters}
          onToggleFilters={() => setShowFilters((v) => !v)}
          onUpdateFilter={updateFilter}
          onClearFilters={clearFilters}
          onRefresh={handleRefresh}
          totalCount={totalCount}
          filteredCount={totalCount}
          isMobile={isMobile}
        />

        {/* ── Mobile: Card list ──────────────────────────────────────────── */}
        {isMobile ? (
          <>
            {loading
              ? [1, 2, 3, 4, 5].map((k) => (
                  <Skeleton key={k} variant="rounded" height={160} sx={{ mb: 1.5, borderRadius: 2 }} />
                ))
              : invoices.length === 0
                ? (
                  <Box textAlign="center" py={6}>
                    <ReceiptIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
                    <Typography color="text.secondary">No invoices found</Typography>
                    {hasActiveFilters && (
                      <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>Clear filters</Button>
                    )}
                  </Box>
                )
                : invoices.map((inv) => (
                    <InvoiceMobileCard
                      key={inv.invoiceId}
                      inv={inv}
                      onView={() => handleView(inv)}
                      onEdit={() => handleEdit(inv)}
                      onDelete={() => handleDelete(inv.invoiceId, inv.invoiceType)}
                      onRemind={
                        Number(inv.dueAmount ?? 0) > 0 ? () => openReminder(inv) : undefined
                      }
                    />
                  ))
            }
            {/* Mobile pagination */}
            {!loading && totalCount > 0 && (
              <Stack alignItems="center" spacing={1} mt={2} mb={1}>
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={(_, p) => { setPage(p - 1); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                  color="primary"
                  size="small"
                  showFirstButton
                  showLastButton
                />
                <Typography variant="caption" color="text.secondary">
                  Page {page + 1} of {totalPages} · {totalCount} invoices
                </Typography>
              </Stack>
            )}
          </>
        ) : (
          /* ── Desktop / Tablet: Table ────────────────────────────────── */
          <>
            <TableContainer
              component={Paper}
              variant="outlined"
              sx={{ borderRadius: 2, mb: 1.5 }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow sx={{ "& th": { bgcolor: "grey.100", fontWeight: 700, fontSize: 12 } }}>
                    <TableCell sx={{ width: 55 }}>S.No</TableCell>
                    <TableCell sx={{ width: 110 }}>Actions</TableCell>

                    {/* Sortable columns — now server-side, sorts the WHOLE filtered dataset */}
                    {[
                      { field: "invoiceId",   label: "Invoice ID",   width: 160 },
                      { field: "customerName",label: "Customer",     width: 180 },
                      { field: "invoiceDate", label: "Invoice Date", width: 110 },
                      { field: "dueDate",     label: "Due Date",     width: 100 },
                    ].map(({ field, label, width }) => (
                      <TableCell key={field} sx={{ width }}>
                        <TableSortLabel
                          active={sortField === field}
                          direction={sortField === field ? sortOrder : "asc"}
                          onClick={() => handleSort(field)}
                        >
                          {label}
                        </TableSortLabel>
                      </TableCell>
                    ))}

                    <TableCell sx={{ width: 100 }}>Type</TableCell>
                    <TableCell sx={{ width: 85  }} align="right">Subtotal</TableCell>
                    {!isTablet && <TableCell sx={{ width: 80  }} align="right">GST</TableCell>}
                    {!isTablet && <TableCell sx={{ width: 80  }} align="right">Disc</TableCell>}
                    <TableCell sx={{ width: 100 }} align="right">Total</TableCell>
                    <TableCell sx={{ width: 100 }} align="right">Paid</TableCell>
                    <TableCell sx={{ width: 100 }} align="right">Due</TableCell>
                    <TableCell sx={{ width: 90  }}>Status</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading
                    ? Array.from({ length: pageSize }).map((_, k) => (
                        <TableRow key={k}>
                          {Array.from({ length: 14 }).map((__, c) => (
                            <TableCell key={c}><Skeleton height={20} /></TableCell>
                          ))}
                        </TableRow>
                      ))
                    : invoices.length === 0
                      ? (
                        <TableRow>
                          <TableCell colSpan={14} align="center" sx={{ py: 6 }}>
                            <ReceiptIcon sx={{ fontSize: 48, color: "grey.300", mb: 1, display: "block", mx: "auto" }} />
                            <Typography color="text.secondary">No invoices match the current filters.</Typography>
                            {hasActiveFilters && (
                              <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>Clear filters</Button>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                      : invoices.map((inv, idx) => {
                          const due = Number(inv.dueAmount ?? 0);
                          return (
                            <TableRow
                              key={inv.invoiceId}
                              hover
                              sx={{
                                "&:hover": { bgcolor: "primary.50" },
                                // Subtle tint by status
                                bgcolor:
                                  inv.status === "paid"   ? "rgba(46,125,50,0.03)"  :
                                  inv.status === "cancel" ? "rgba(211,47,47,0.03)"  : "inherit",
                              }}
                            >
                              {/* S.No */}
                              <TableCell sx={{ color: "text.secondary", fontSize: 12 }}>
                                {serialOffset + idx + 1}
                              </TableCell>

                              {/* Actions */}
                              <TableCell>
                                <Stack direction="row" spacing={0.3}>
                                   
                                  <Tooltip title="View Invoice">
                                    <IconButton size="small" color="primary" onClick={() => handleView(inv)}>
                                      <VisibilityIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Edit Invoice">
                                    <IconButton size="small" onClick={() => handleEdit(inv)}>
                                      <EditIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete / Cancel Invoice">
                                    <IconButton size="small" color="error" onClick={() => handleDelete(inv.invoiceId, inv.invoiceType)}>
                                      <DeleteIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                  {due > 0 && (
                                    <Tooltip title="Send Payment Reminder">
                                      <IconButton size="small" sx={{ color: "#25D366" }} onClick={() => openReminder(inv)}>
                                        <WhatsAppIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Stack>
                              </TableCell>

                              {/* Invoice ID — clickable */}
                              <TableCell>
                                <Typography
                                  variant="body2"
                                  color="primary.main"
                                  fontWeight={600}
                                  sx={{ cursor: "pointer", textDecoration: "underline", fontSize: 10,width: 100}}
                                  onClick={() => handleView(inv)}
                                >
                                  {inv.invoiceId}
                                </Typography>
                              </TableCell>

                              <TableCell sx={{ fontSize: 12, maxWidth: 180 }}>
                                <Typography variant="body2" noWrap>{inv.customerName ?? "—"}</Typography>
                              </TableCell>
                              <TableCell sx={{ fontSize: 12 }}>{fmtDate(inv.invoiceDate)}</TableCell>
                              <TableCell sx={{ fontSize: 12 }}>{fmtDate(inv.dueDate)}</TableCell>
                              <TableCell>{typeChip(inv.invoiceType)}</TableCell>

                              <TableCell align="right" sx={{ fontSize: 12 }}>
                                {fmtCurrency(inv.subTotalAmount)}
                              </TableCell>
                              {!isTablet && (
                                <TableCell align="right" sx={{ fontSize: 12 }}>
                                  {fmtCurrency(inv.totalTax)}
                                </TableCell>
                              )}
                              {!isTablet && (
                                <TableCell align="right" sx={{ fontSize: 12 }}>
                                  {fmtCurrency(inv.totalDiscount)}
                                </TableCell>
                              )}

                              {/* Grand Total */}
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight={700} fontSize={12}>
                                  {fmtCurrency(inv.grandTotal)}
                                </Typography>
                              </TableCell>

                              {/* Paid Amount */}
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight={600} fontSize={12} color="success.main">
                                  {fmtCurrency(inv.totalPaidAmount)}
                                </Typography>
                              </TableCell>

                              {/* Due Amount */}
                              <TableCell align="right">
                                <Typography
                                  variant="body2"
                                  fontWeight={600}
                                  fontSize={12}
                                  color={due > 0 ? "error.main" : "success.main"}
                                >
                                  {fmtCurrency(due)}
                                </Typography>
                              </TableCell>

                              {/* Status */}
                              <TableCell>{statusChip(inv.status)}</TableCell>
                            </TableRow>
                          );
                        })
                  }
                </TableBody>
              </Table>
            </TableContainer>

            {/* ── Pagination footer ── */}
            {!loading && totalCount > 0 && (
              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
                px={0.5}
              >
                {/* Rows per page */}
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="caption" color="text.secondary">Rows per page:</Typography>
                  <Select
                    size="small"
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                    sx={{ fontSize: 13, minWidth: 70 }}
                  >
                    {[10, 20, 50, 100].map((n) => (
                      <MenuItem key={n} value={n}>{n}</MenuItem>
                    ))}
                  </Select>
                  <Typography variant="caption" color="text.secondary">
                    {serialOffset + 1}–{Math.min(serialOffset + pageSize, totalCount)} of {totalCount}
                    {hasActiveFilters ? ` (filtered)` : ""}
                  </Typography>
                </Stack>

                {/* Page navigation */}
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={(_, p) => { setPage(p - 1); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                  color="primary"
                  size="small"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            )}
          </>
        )}
      </Container>

      <Box sx={{ width: "100%", mt: isMobile ? 4 : 6 }}>
        <Footer />
      </Box>
      <PaymentReminderModal
        open={reminderInvoices.length > 0}
        onClose={() => setReminderInvoices([])}
        invoices={reminderInvoices}
        customerName={reminderCustomerName}
        customerPhone={reminderPhone}
      />
    </>
  );
};

export default ViewInvoice;